// extracted by mini-css-extract-plugin
module.exports = {"org":"UserInviteView_org__1JKYz"};